export function getCreatedVibeProjectId(response) {
    return response && response.id ? response.id : null
}
